export default "/images/beverages_sm.jpg?859fc78490a23ad856a89e50aa8123cf";